import { render } from "./TheGarmentPopup.vue?vue&type=template&id=5d113698&ts=true"
import script from "./TheGarmentPopup.vue?vue&type=script&lang=ts"
export * from "./TheGarmentPopup.vue?vue&type=script&lang=ts"

import exportComponent from "/Users/angeloquijano/Git/IWARI/iwari-vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__